import { useWSQuery, WSQueryConfig } from "@ws-react-query";
import { getInsuranceImport } from "../../../services/api/insurance/import/getInsuranceImport";
import { InsuranceImportWithJobs } from "../../../services/api/insurance/import/types";
import { WSServiceError } from "../../../utils/serviceHelper";
import { QUERY_INSURANCE_IMPORT } from "../keys";

export const useQueryInsuranceImport = (
  insuranceImportId: string,
  config?: WSQueryConfig<InsuranceImportWithJobs, WSServiceError>
) => {
  return useWSQuery(
    [QUERY_INSURANCE_IMPORT, insuranceImportId],
    () => getInsuranceImport(insuranceImportId),
    {
      ...config
    }
  );
};
